/**
 * @file routes.ts
 *
 * @fileoverview Include routes for the application.
 */
const jobiqoRoutesConfig = require('./../src/jobiqo/config/routes');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

module.exports = mergeDeepRight(jobiqoRoutesConfig, {
  // Insert config here. this will be deep merged with config from jobiqo. Arrays are not deep mergeable
  // so make sure to cover those with [...jobiqoCompanyConfig.public.SOME_KEY_THAT_IS_ARRAY, new_item ]
  routes: [...jobiqoRoutesConfig.routes],
  redirects: [
    ...jobiqoRoutesConfig.redirects,
    // Redirect all homepage/job search pagination pages to job search page.
    {
      source: '/(\\d{1,})',
      destination: '/jobs',
      permanent: true,
    },
    // Example: /?search%5Bq%5D=abc
    {
      source: '/',
      has: [
        {
          type: 'query',
          key: 'search[q]',
          value: '(?<search_term>.*)',
        }
      ],
      permanent: true,
      destination: '/jobs?search=:search_term',
    },
    // Example: /?search%5Bp%5D%5Bs%5D%5Bj%5D%5Badvertisment-type%5D%5B%5D=Schichtarbeit
    {
      source: '/',
      has: [
        {
          type: 'query',
          key: 'search[p][s][j][advertisment-type][]',
          value: '(?<search_term>.*)',
        }
      ],
      permanent: true,
      destination: '/jobs?search=:search_term',
    },
    // Example: /?search%5Bp%5D%5Bs%5D%5Bj%5D%5Bcategory%5D%5B%5D=Bauwesen%2C+Architektur
    {
      source: '/',
      has: [
        {
          type: 'query',
          key: 'search[p][s][j][category][]',
          value: '(?<search_term>.*)',
        }
      ],
      permanent: true,
      destination: '/jobs?search=:search_term',
    },
  ],
});
